import { FormControl, FormGroup, Validators } from '@angular/forms';
import { exactLengthValidator } from '../../../validators/exact-length.validator';

export type VerificationCodeFormGroup = FormGroup<{
  code: FormControl<string>;
}>;

export function createVerificationCodeFormGroup(requiredLength: number | null = 6): VerificationCodeFormGroup {
  const validators = [Validators.required];
  if (requiredLength !== null) {
    validators.push(exactLengthValidator(requiredLength, false));
  }
  return new FormGroup({
    code: new FormControl<string>('', {
      nonNullable: true,
      validators
    })
  });
}
